import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { SHARED_USER_ID } from '@/constants'
import 'react-table/react-table.css'
import * as moment from 'moment'

import { Grid, Typography, Modal, Paper, LinearProgress } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import { ALABASTER } from '@/constants'
import CheckIcon from 'material-ui-icons/Check'
import IconButton from 'material-ui/IconButton'
import AlchemyReadingCalendar from '@/components/ChartTypes/AlchemyReadingCalendar'
import AlchemyReadingWeeklyView from '@/components/ChartTypes/AlchemyReadingWeeklyView'
import AlchemyReadingWeeklyAvg from '@/components/ChartTypes/AlchemyReadingWeeklyAvg'
import AlchemyReadingCurrentBookBurnDown from '@/components/ChartTypes/AlchemyReadingCurrentBookBurnDown'
import ImportContactsIcon from 'material-ui-icons/ImportContacts'
import ClearIcon from 'material-ui-icons/Clear'

import { READ_DATASETNAME, READ_DATASETS } from '@/graphql/queries/dataset'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'

const styles = theme => ({
  paperGoalBlock: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 5,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperCalendarView: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #eeeeee',
    color: 'grey'
  },
  todayPanelGrid: {
    position: 'relative',
    textAlign: 'center',
    padding: 20
  },
  iconTodayTime: {
    height: 24,
    width: 24
  },
  button: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperAddTodayMoreInfo: {
    boxShadow: '0px 0px 10px #eeeeee',
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divBtnAddNew: {
    position: 'relative',
    height: 70,
    textAlign: 'center'
  },
  iconBtnCheck: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  listItemGetUpTime: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: theme.spacing.unit * 0.8
  },
  iconGetUpTimeView: {
    color: 'rgba(0, 0, 0, .1)',
    width: 30,
    height: 30
  },
  weightText: {
    textAlign: 'center',
    padding: 0
  },
  textGetUpTimeView: {
    fontSize: 18,
    color: 'grey'
  },
  textGetUpDate: {
    fontSize: 12,
    color: 'lightgrey'
  },
  paperWidget: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit,
    height: 40,
    borderRadius: theme.spacing.unit * 2
  },
  divAddModalButton: {
    textAlign: 'right',
    paddingRight: theme.spacing.unit * 2
  },
  iconBtnCheckAdd: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    marginBottom: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit
  },
  paperWidgetComment: {
    textAlign: 'left',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit,
    height: 80,
    borderRadius: theme.spacing.unit * 2
  },
  listItemSessionView: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.016)',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: theme.spacing.unit * 0.8
  },
  divWidgetMood: {
    textAlign: 'left',
    height: 80,
    borderRadius: theme.spacing.unit * 2
  },
  paperWidgetMood: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    borderRadius: theme.spacing.unit * 2
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  toolbar: {
    backgroundColor: ALABASTER,
    color: 'white'
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -15,
    left: 0,
    right: 0,
    margin: '0 auto'
  },
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  },
  innerWrapTimer: {
    position: 'relative',
    top: -230
  },
  innerWrapTimerText: {
    position: 'relative',
    top: -250
  },
  innerWrapTimerEmoji: {
    position: 'relative',
    top: -100,
    height: 1
  },
  centerBlock: {
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: 270,
    marginTop: theme.spacing.unit * 1.5
  },
  centerBlockBtns: {
    textAlign: 'center',
    width: '100%'
  },
  icon: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  iconTiny: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    height: 20,
    width: 20,
    margin: theme.spacing.unit
  },
  iconTinyDark: {
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #aaaaaa',
    height: 20,
    width: 20,
    margin: theme.spacing.unit
  },
  iconDark: {
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #aaaaaa',
    margin: theme.spacing.unit
  },
  iconSetDark: {
    color: 'lightgrey',
    height: 28,
    width: 28,
    margin: 5
  },
  iconEdit: {
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #aaaaaa',
    margin: theme.spacing.unit,
    position: 'relative',
    top: -90
  },
  iconPause: {
    margin: theme.spacing.unit,
    height: 180,
    width: 180
  },
  iconHistoryEdit: {
    height: 24,
    width: 24
  },
  iconBigButtons: {
    fontSize: 170
  },
  iconBtnCurrentBookRefresh: {
    color: 'lightgrey',
    height: 16,
    width: 16
  },
  iconBtnCurrentBook: {
    color: 'lightgrey',
    height: 30,
    width: 30
  },
  textInfo: {
    fontSize: 11,
    color: 'grey',
    opacity: 0.8,
    textAlign: 'left',
    backgroundColor: ALABASTER,
    padding: '3%'
  },
  calendar: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: window.innerWidth
  },
  panel: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    width: '100%'
  },
  modalZero: {
    position: 'absolute',
    width: window.innerWidth * 0.4,
    height: window.innerWidth * 0.2,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    boxShadow: theme.shadows[5],
    padding: window.innerWidth * 0.2,
    margin: window.innerWidth * 0.1,
    textAlign: 'center',
    top: window.innerHeight * 0.5
  },
  modalContent: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  listItemSleepTimeComplete: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  modalContentWhite: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  modalContentSmall: {
    height: 80,
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#f8f8f8',
    paddingLeft: window.innerWidth * 0.15
  },
  modalContentSmallTime: {
    height: 80,
    width: '100%',
    textAlign: 'center',
    backgroundColor: '#f8f8f8'
  },
  modalContentDone: {
    height: 50,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER
  },
  textField: {
    width: window.innerWidth * 0.4
  },
  textFieldSmall: {
    width: window.innerWidth * 0.23
  },
  textFieldMedium: {
    width: window.innerWidth * 0.33
  },
  textFieldShortLength: {
    width: window.innerWidth * 0.22
  },
  textFieldTimeSmall: {
    fontSize: 12,
    color: 'grey'
  },
  textFieldTimeTiny: {
    fontSize: 11,
    color: 'silver'
  },
  iconSleepScore: {
    color: 'rgba(0, 0, 0, .04)',
    width: 55,
    height: 55
  },
  editIcons: {
    color: 'rgba(0, 0, 0, .1)',
    width: 55,
    height: 55
  },
  editIconsMedium: {
    color: 'rgba(0, 0, 0, .1)',
    width: 35,
    height: 35
  },
  iconSleepAtTimeDate: {
    color: 'rgba(0, 0, 0, .1)',
    width: 20,
    height: 20
  },
  editIconsLight: {
    color: 'rgba(255, 255, 255, .1)',
    width: 55,
    height: 55
  },
  editIconsSmall: {
    color: 'rgba(0, 0, 0, .1)',
    width: 20,
    height: 20
  },
  paperRoot: {
    margin: theme.spacing.unit * 4,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperRootCurrentBook: {
    margin: theme.spacing.unit * 4,
    boxShadow: '0px 0px 10px #eeeeee',
    height: 180
  },
  paperRootCurrentBookDark: {
    margin: theme.spacing.unit * 4,
    backgroundColor: 'dimgrey',
    boxShadow: '0px 0px 6px #888888',
    height: 180
  },
  gridLeft: {
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'rgba(222,184,135, .1)',
    height: 120,
    width: 93,
    position: 'relative',
    top: 30,
    left: 30
  },
  gridLeftDark: {
    boxShadow: '0px 0px 2px #999999',
    backgroundColor: 'rgba(222,184,135, .2)',
    height: 120,
    width: 93,
    position: 'relative',
    top: 30,
    left: 30
  },
  gridLeftCommon: {
    alignItems: 'center'
  },
  gridRight: {
    position: 'relative',
    textAlign: 'left',
    height: 120,
    width: 140,
    top: 25,
    left: 46,
    margin: 20
  },
  gridRightButtons: {
    position: 'relative',
    textAlign: 'left',
    height: 120,
    width: 140,
    top: 5,
    left: 46,
    margin: 20
  },
  bookBlock: {
    position: 'relative',
    textAlign: 'center',
    width: 93
  },
  iconBook: {
    color: 'rgba(0, 0, 0, .1)',
    width: 60,
    height: 60
  },
  linearColorPrimary: {
    backgroundColor: 'rgba(0, 0, 0, .1)'
  },
  linearBarColorPrimary: {
    backgroundColor: 'rgba(80, 227, 194, .4)'
  },
  linearBarColorPrimaryComplete: {
    backgroundColor: 'lightgreen'
  },
  linearBarColorPrimaryGoal: {
    backgroundColor: 'rgba(168, 169, 255,0.5)'
  },
  textFieldInput: {
    position: 'relative',
    width: 45,
    height: 20,
    top: -38,
    left: 95
  },
  textFieldInputNew: {
    position: 'relative',
    width: 45,
    height: 20,
    top: -128,
    left: 165
  },
  gridPageProgress: {
    left: -46
  },
  modalContentInputComment: {
    width: '100%',
    paddingLeft: window.innerWidth * 0.1,
    backgroundColor: 'rgba(0, 0, 0, 0.016)',
    top: -120
  },
  modalAddTodayDark: {
    display: 'inline-block',
    backgroundColor: 'rgba(180, 180, 180, 1)',
    overflow: 'scroll'
  },
  modalAddToday: {
    display: 'inline-block',
    overflow: 'scroll'
  },
  paperAddToday: {
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divAddTpday: {
    position: 'relative',
    alignItems: 'center',
    width: '100%'
  },
  divClearButton: {
    textAlign: 'right',
    height: 26
  },
  iconClearDark: {
    color: 'rgba(255, 255, 255, .8)',
    fontSize: 26
  },
  iconClear: {
    color: 'rgba(0, 0, 0, .2)',
    fontSize: 26
  },
  textFieldColor: {
    color: 'lightgrey'
  },
  divTodayPanelTitle: {
    textAlign: 'left',
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 4.5
  },
  textFieldDarkMode: {
    color: 'silver'
  }
})

var maxPage = ''
var percentRead = 0

@withApollo
@inject('resultUserReading')
@inject('resultUserReadingPref')
@inject('resultBookPref')
@observer
@graphql(READ_DATASETS)
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAME, {
  name: 'readReadingDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultReading',
      userId: global.localStorage.getItem(SHARED_USER_ID)
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readUserReadingPreference',
  options: ({ props }) => ({
    variables: {
      dataName: 'defaultUserReadingPreference',
      userId: global.localStorage.getItem(SHARED_USER_ID)
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readUserBookPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserBookPreference',
      userId: global.localStorage.getItem(SHARED_USER_ID)
    }
  })
})
@withRouter
@withStyles(styles)
export default class AlchemyReadingShare extends Component {
  constructor(props) {
    super(props)
    this.state = {
      OpenView: false,

      session: 30,
      break: 5,
      timer: 30 * 60,
      isSessionNow: true,
      isPaused: false,
      eAngle: 0,
      isUpdated: false,
      token: 'session',
      isCompleted: false,
      initialStart: true,
      initialStartTimer: true,
      timeStart: '',
      isExtend: false,
      currentSession: [],
      minsRead: 0,
      hasHistory: true,
      percentRead: 0,
      maxPage: '',
      time: 0,
      isCommented: false,
      comment: ''
    }
  }

  handleOpenView = date => {
    this.props.resultUserReading.updatesessionsDataByDate(date)

    this.setState({ OpenView: true })
  }

  handleCloseView = () => {
    this.setState({
      OpenView: false
    })
  }

  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {},
      ret = []
    var newCols = []
    for (var i = 0; i < dataArray.length; i++) {
      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {}
      }

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) === -1) {
        newCols.push(dataArray[i][colIndex])
      }
    }

    for (var key in result) {
      var sessions = []
      var mins = 0
      var pages = 0
      for (var j = 0; j < dataArray.length; j++) {
        if (dataArray[j].date === key) {
          sessions.push(dataArray[j])
          result[dataArray[j][rowIndex]][dataArray[j][colIndex]] = sessions
          mins += parseFloat(dataArray[j].durationMin, 10)
          pages += parseFloat(dataArray[j].pages, 10)
          result[dataArray[j][rowIndex]][2] = mins
          result[dataArray[j][rowIndex]][3] = pages
        }
      }
    }

    newCols.sort(function(a, b) {
      return new Date(a) - new Date(b)
    })
    var item = []

    //Add content
    for (key in result) {
      item = []
      item.push(key)
      for (i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || '')
        item.push(result[key][2])
        item.push(result[key][3])
      }
      ret.push(item)
    }
    return ret
  }

  render() {
    const { classes } = this.props
    const userId = global.localStorage.getItem(SHARED_USER_ID)

    if (this.props.readReadingDefault.loading) {
      return <div>Loading reading data ... </div>
    }

    // load readingdata
    if (this.props.readReadingDefault.allDataSets.length === 1) {
      this.props.resultUserReading.userId = userId
      if (this.props.readReadingDefault.allDataSets[0].dataPoints) {
        var l = JSON.parse(
          this.props.readReadingDefault.allDataSets[0].dataPoints
        ).length
        if (l > 0) {
          // store mgt
          if (this.props.resultUserReading.readingData.length > 0) {
            if (
              this.props.resultUserReading.userId !== '' &&
              this.props.resultUserReading.userId !== userId
            ) {
              this.props.resultUserReading.updateReadingData(
                JSON.parse(
                  this.props.readReadingDefault.allDataSets[0].dataPoints
                )
              )
            }
          } else if (this.props.resultUserReading.readingData.length === 0) {
            //('defualt table is there.')
            this.props.resultUserReading.updateReadingData(
              JSON.parse(
                this.props.readReadingDefault.allDataSets[0].dataPoints
              )
            )
          } else {
            console.log('error')
          }
        } else {
          console.log('there is table, but datapoints length not > 0 ')
          // store mgt
          if (this.props.resultUserReading.readingData.length > 0) {
            if (
              this.props.resultUserReading.userId !== '' &&
              this.props.resultUserReading.userId !== userId
            ) {
              this.props.resultUserReading.updateReadingData([])
            }
          }
        }
      } else {
        console.log('there is table, but no datapoints')
        // store mgt
        if (this.props.resultUserReading.readingData.length > 0) {
          if (
            this.props.resultUserReading.userId !== '' &&
            this.props.resultUserReading.userId !== userId
          ) {
            this.props.resultUserReading.updateReadingData([])
          }
        }
      }
    } else if (this.props.readReadingDefault.allDataSets.length === 0) {
      // created?
      if (!this.props.resultUserReading.created) {
        // create
        //('defualt table to be added')
        this.createDataSet(
          JSON.stringify(this.props.resultUserReading.readingData)
        )
        this.props.resultUserReading.updateCreated()
        // store mgt
        if (this.props.resultUserReading.readingData.length > 0) {
          if (
            this.props.resultUserReading.userId !== '' &&
            this.props.resultUserReading.userId !== userId
          ) {
            this.props.resultUserReading.updateReadingData([])
          }
        }
      }
    } else {
      return (
        <div>
          Error, plesae contact our support team [readReadingDefault:{' '}
          {this.props.readReadingDefault.allDataSets.length}]
        </div>
      )
    }

    // load book pref data
    if (this.props.readUserBookPreference.loading) {
      return <div>Loading readUserBookPreference data ... </div>
    }

    if (this.props.readUserBookPreference.allDataSets.length === 1) {
      if (this.props.readUserBookPreference.allDataSets[0].dataPoints !== '') {
        var allBooks = JSON.parse(
          this.props.readUserBookPreference.allDataSets[0].dataPoints
        )
        var currentBook = allBooks.filter(b => b.isCurrent === '1')
        if (currentBook.length === 1) {
          this.props.resultBookPref.updateBooks(allBooks)
          this.props.resultBookPref.updateBook(currentBook[0])
        } else if (currentBook.length > 1) {
          return <div>error: current book is more than 1</div>
        } else if (currentBook.length === 0) {
          this.props.resultBookPref.updateBooks(allBooks)
          this.props.resultBookPref.updateBook([])
        }
      }
    } else if (this.props.readUserBookPreference.allDataSets.length === 0) {
      if (this.props.resultBookPref.bookPrefDatasetId === '') {
        this.props.resultBookPref.updateBooks([])
        this.props.resultBookPref.updateBook([])
      }
    } else {
      return (
        <div>
          Error, plesae contact our support team [readUserBookPreference:{' '}
          {this.props.readUserBookPreference.allDataSets.length}]
        </div>
      )
    }

    // load reading pref data
    if (this.props.readUserReadingPreference.loading) {
      return <div>Loading user reading preference data ... </div>
    }

    if (this.props.resultUserReadingPref.data.length === 0) {
      if (this.props.readUserReadingPreference.allDataSets.length === 1) {
        if (
          this.props.readUserReadingPreference.allDataSets[0].dataPoints !== ''
        ) {
          //('default reading pref data is there')
          this.props.resultUserReadingPref.updateData(
            JSON.parse(
              this.props.readUserReadingPreference.allDataSets[0].dataPoints
            )
          )
          this.props.resultUserReadingPref.updateGoal()
        }
      } else if (
        this.props.readUserReadingPreference.allDataSets.length === 0
      ) {
        if (!this.props.resultUserReadingPref.created) {
          console.log('create user reading pref default table')
          this.createDataSetUserReadingPref(
            JSON.stringify(this.props.resultUserReadingPref.data)
          )
          this.props.resultUserReadingPref.updateCreated()
        }
      } else {
        return (
          <div>
            Error, plesae contact our support team [resultUserReadingPref:{' '}
            {this.props.readUserReadingPreference.allDataSets.length}]
          </div>
        )
      }
    }

    // aggregate reading data to daily
    var dataSessionsByDate = this.getPivotArray(
      this.props.resultUserReading.readingData,
      'date',
      '',
      ''
    )

    maxPage = this.props.resultBookPref.book.maxPage
    percentRead = this.props.resultBookPref.book.percentRead

    //current book data
    var currentBookData = this.props.resultUserReading.readingData.filter(
      e => e.bookId === this.props.resultBookPref.book.id
    )

    //sort above data
    currentBookData.sort(function(a, b) {
      return new Date(a.timeComplete) - new Date(b.timeComplete)
    })

    return (
      <div>
        {this.props.resultBookPref.book &&
        this.props.resultBookPref.book.length !== 0 ? (
          <Paper className={classes.paperRootCurrentBook}>
            <Grid container spacing={0}>
              <Grid item className={classes.gridLeft}>
                <div id="bookblock" className={classes.bookBlock}>
                  <ImportContactsIcon className={classes.iconBook} />
                  <Typography
                    variant="body1"
                    id="bookName"
                    style={{
                      paddingLeft: 8,
                      paddingRight: 2,
                      textAlign: 'left',
                      fontSize: 12
                    }}
                  >
                    {this.props.resultBookPref.book.bookName}
                  </Typography>
                  <Typography
                    variant="caption"
                    id="bookAuthor"
                    style={{
                      paddingLeft: 8,
                      paddingRight: 8,
                      fontSize: 9,
                      textAlign: 'left'
                    }}
                  >
                    {this.props.resultBookPref.book.bookAuthor}
                  </Typography>
                </div>
              </Grid>
              <Grid
                item
                container
                direction="column"
                spacing={0}
                className={classes.gridRightButtons}
              >
                <Grid item>
                  <div style={{ position: 'relative', top: 98 }}>
                    <Typography style={{ color: 'lightgrey', fontSize: 12 }}>
                      Progress:{' '}
                      {this.state.percentRead
                        ? this.state.percentRead
                        : percentRead}%{' '}
                      {this.state.percentRead >= 100 || percentRead >= 100 ? (
                        <CheckIcon style={{ color: 'green', fontSize: 12 }} />
                      ) : (
                        ''
                      )}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={
                        this.state.percentRead
                          ? this.state.percentRead
                          : percentRead
                      }
                      classes={{
                        colorPrimary: classes.linearColorPrimary,
                        barColorPrimary:
                          this.state.percentRead >= 100 || percentRead >= 100
                            ? classes.linearBarColorPrimaryComplete
                            : classes.linearBarColorPrimary
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        ) : (
          <Paper className={classes.paperRootCurrentBook}>
            <Grid container spacing={0}>
              <Grid item className={classes.gridLeft}>
                <div id="bookblock" className={classes.bookBlock}>
                  <ImportContactsIcon className={classes.iconBook} />
                </div>
              </Grid>
              <Grid
                item
                container
                direction="column"
                spacing={0}
                className={classes.gridRight}
              >
                <Grid item xs>
                  <Typography
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.props.history.push('/books')}
                  >
                    Choose a book to read
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        )}

        {this.props.resultBookPref.book &&
          this.props.resultBookPref.book.length !== 0 &&
          this.props.resultUserReading.readingData.length !== 0 &&
          (this.state.maxPage > 0 || maxPage > 0) &&
          currentBookData.length > 0 && (
            <div>
              <div className={classes.divTodayPanelTitle}>
                <Typography
                  variant="caption"
                  style={{ color: 'lightgrey', fontSize: 15 }}
                >
                  Book: {currentBookData[0].bookName}
                </Typography>{' '}
              </div>
              <Paper className={classes.paperCalendarView}>
                <AlchemyReadingCurrentBookBurnDown
                  data={currentBookData}
                  width={
                    window.innerWidth < 630 * 1.2
                      ? window.innerWidth
                      : 630 * 1.2
                  }
                  height={
                    window.innerWidth < 630 * 1.2
                      ? window.innerWidth * 0.76
                      : 480 * 1.2
                  }
                  totalPages={this.props.resultBookPref.book.totalPages}
                  maxPage={this.props.resultBookPref.book.maxPage}
                  type={'readingTracker'}
                  goal={this.props.resultUserReadingPref.goal}
                  action={(d, t) => t !== 'add' && this.handleOpenView(d)}
                />
              </Paper>
            </div>
          )}

        {this.props.resultBookPref.book &&
          this.props.resultBookPref.book.length !== 0 &&
          this.props.resultUserReading.readingData.length !== 0 && (
            <div>
              <div>
                <div className={classes.divTodayPanelTitle}>
                  <Typography
                    variant="caption"
                    style={{ color: 'lightgrey', fontSize: 15 }}
                  >
                    Weekly Reading
                  </Typography>
                  <Typography
                    variant="caption"
                    style={{ color: 'lightgrey', fontSize: 12, paddingTop: 10 }}
                  >
                    <span
                      style={{
                        color: 'white',
                        backgroundColor: 'rgba(228,228,228,.7)',
                        fontSize: 18
                      }}
                    >
                      ★
                    </span>{' '}
                    10+ pages{' '}
                    <span
                      style={{
                        color: 'yellow',
                        backgroundColor: 'rgba(228,228,228,.7)',
                        fontSize: 18
                      }}
                    >
                      ★
                    </span>{' '}
                    20+ pages{' '}
                    <span
                      style={{
                        color: 'papayawhip',
                        backgroundColor: 'rgba(228,228,228,.7)',
                        fontSize: 18
                      }}
                    >
                      ★
                    </span>{' '}
                    30+ pages
                  </Typography>
                </div>
                <Paper className={classes.paperCalendarView}>
                  <AlchemyReadingWeeklyView
                    data={dataSessionsByDate}
                    width={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth
                        : 630 * 1.2
                    }
                    height={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth * 0.76
                        : 480 * 1.2
                    }
                    type={'readingTracker'}
                    goal={this.props.resultUserReadingPref.goal}
                    action={(d, t) => t !== 'add' && this.handleOpenView(d)}
                  />
                </Paper>
              </div>

              <div>
                <div className={classes.divTodayPanelTitle}>
                  <Typography
                    variant="caption"
                    style={{ color: 'lightgrey', fontSize: 15 }}
                  >
                    Monthly Streak
                  </Typography>
                </div>
                <Paper className={classes.paperCalendarView}>
                  <AlchemyReadingCalendar
                    shared={true}
                    data={dataSessionsByDate}
                    width={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth * 1.24
                        : 630 * 1.2
                    }
                    height={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth * 1.24 * 0.76
                        : 480 * 1.2
                    }
                    type={'readingTracker'}
                    goal={this.props.resultUserReadingPref.goal}
                    action={(d, t) => t !== 'add' && this.handleOpenView(d)}
                  />
                </Paper>
              </div>

              <div>
                <div className={classes.divTodayPanelTitle}>
                  <Typography
                    variant="caption"
                    style={{ color: 'lightgrey', fontSize: 15 }}
                  >
                    Weekly Average Trend
                  </Typography>
                  <Typography
                    variant="caption"
                    style={{ color: 'lightgrey', fontSize: 12, paddingTop: 10 }}
                  >
                    <span style={{ color: 'rgba(234,234,255,1', fontSize: 14 }}>
                      ⬤
                    </span>{' '}
                    Speed (pages / hour){' '}
                    <span style={{ color: 'rgba(196,240,196,1', fontSize: 24 }}>
                      ■
                    </span>{' '}
                    pages read / day (weekly avg)
                  </Typography>
                </div>
                <Paper className={classes.paperCalendarView}>
                  <AlchemyReadingWeeklyAvg
                    data={dataSessionsByDate}
                    width={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth
                        : 630 * 1.2
                    }
                    height={
                      window.innerWidth < 630 * 1.2
                        ? window.innerWidth * 0.76
                        : 480 * 1.2
                    }
                    type={'readingTracker'}
                    goal={this.props.resultUserReadingPref.goal}
                    action={(d, t) => t !== 'add' && this.handleOpenView(d)}
                  />
                </Paper>
              </div>
            </div>
          )}

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.OpenView}
          onClose={this.handleCloseView}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddToday}>
            <div id="GetUpTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseView}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                {this.props.resultUserReading.sessionsDataByDate.map(s => (
                  <List key={s.id}>
                    <ListItem key={s.id} className={classes.listItemGetUpTime}>
                      <ListItemIcon>
                        <ImportContactsIcon
                          className={classes.iconGetUpTimeView}
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.weightText}
                        primary={
                          s.timeStart === ''
                            ? moment(new Date(s.timeComplete)).format('HH:mm')
                            : moment(new Date(s.timeStart)).format('HH:mm') +
                              '~' +
                              moment(new Date(s.timeComplete)).format('HH:mm')
                        }
                        classes={{
                          primary: classes.textGetUpTimeView,
                          secondary: classes.textGetUpDate
                        }}
                        secondary={'On ' + moment(new Date(s.date)).format('l')}
                      />
                    </ListItem>

                    {(s.durationMin || s.pages || s.bookName) && (
                      <ListItem
                        key={`sessiodetail-${s.id}`}
                        className={classes.listItemSessionView}
                      >
                        {s.durationMin !== '' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.durationMin}
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Mins
                            </Typography>
                          </Paper>
                        )}
                        {s.pages !== '' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.pages}{' '}
                              <span
                                style={{ color: 'lightgrey', fontSize: 12 }}
                              >
                                Pages
                              </span>
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              P{s.pageStart} - P{s.pageEnd}
                            </Typography>
                          </Paper>
                        )}
                        {s.bookName !== '' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.bookName}
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Book Name
                            </Typography>
                          </Paper>
                        )}
                      </ListItem>
                    )}

                    {(s.mood || s.comment) && (
                      <ListItem
                        key={`sessioninfo-${s.id}`}
                        className={classes.listItemSessionView}
                      >
                        {s.mood !== 0 && (
                          <div className={classes.divWidgetMood}>
                            <Paper className={classes.paperWidgetMood}>
                              <Typography
                                style={{ color: 'dimgrey', fontSize: 18 }}
                              >
                                {s.mood === '10'
                                  ? ':)'
                                  : s.mood === '20'
                                    ? ':|'
                                    : this.props.resultUserReading
                                        .sessionsDataByDate[0].mood === '30'
                                      ? ':('
                                      : ''}
                              </Typography>
                            </Paper>
                          </div>
                        )}

                        {s.comment !== '' && (
                          <Paper className={classes.paperWidgetComment}>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Comment
                            </Typography>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {s.comment}
                            </Typography>
                          </Paper>
                        )}
                      </ListItem>
                    )}
                  </List>
                ))}
              </List>
            </div>
          </Paper>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/readingShare.js